function* handleSetAuthToken() {
  yield;
}

export default handleSetAuthToken;
